// src/data/Menu.js

const getDashboardMenu = (user, userRoles) => {
  
  const userRole = user?.user_scope; // 'global' ou 'local'
  const userRoleId = user?.role_id;
  const userMarcheId = user?.id_marche;
  
  // ✅ Vérifier si l'utilisateur a le rôle super_admin
  const isSuperAdmin = userRoles && Array.isArray(userRoles) 
    ? userRoles.some(role => role.name === 'super_admin') 
    : false;
  
  // ✅ Vérifier les rôles spécifiques
  const isAdminEntite = userRoleId === 1002; // ✅ Admin Entité
  const isAdminPrincipal = userRoleId === 1003;
  const isAdminMarche = userRoleId === 1005;
  const isSuperviseur = userRoleId === 1007;
  const isAgent = userRoleId === 1012 || userRoleId === 1013;
  
  // ✅ L'utilisateur a un marché associé
  const hasMarket = !!userMarcheId;
  
  // ✅ Est-ce un agent de marché ?
  const isMarketAgent = hasMarket && (isAdminMarche || isSuperviseur || isAgent || isAdminPrincipal || isAdminEntite);
  
  // ✅ Admin Principal (1003) ne voit PAS le tableau de bord simple
  // ✅ Admin Entité (1002) voit le tableau de bord simple
  const canSeeSimpleDashboard = !isAdminPrincipal && !isAgent;
  
  // ✅ Admin Principal (1003) et Admin Entité (1002) voient les Marchés
  const canSeeMarches = isAdminPrincipal || isAdminEntite;
  
  const canSeeCollectes = isAdminPrincipal || isAdminEntite;
  
  // ✅ Les agents simples (1012, 1013) ne voient PAS la partie Agents
  const canSeeAgents = !isAgent;
  
  // ✅ Les agents simples (1012, 1013) ne voient PAS la partie Rôles & Permissions
  const canSeeRoles = !isAgent;
  
  // ✅ Les agents simples (1012, 1013) ne voient PAS Objectifs
  const canSeeObjectives = !isAgent;
  
  // ✅ Les agents simples voient "Mes primes"
  const canSeeMyPrimes = isAgent;
  
  const canSeePrimes = isAgent;
  
  // ✅ SI L'UTILISATEUR A UN MARCHÉ OU EST ADMIN ENTITÉ/PRINCIPAL
  const useRedevances = hasMarket || isAdminPrincipal || isAdminEntite;
  
  // ✅ L'Admin Entité voit les options Super Admin (sauf certaines réservées)
  const canSeeSuperAdminOptions = isAdminEntite || isSuperAdmin;
  
  // ============================================================
  // 🔥 SECTION RÉUTILISABLE : MES PRIMES
  // Utilisée dans plusieurs menus pour éviter la duplication
  // ============================================================
  const mesPrimesSection = canSeeMyPrimes ? [{
    "label": "Mes Primes",
    "icon": "ri-money-cny-circle-line",
    "submenu": [
      {
        "label": "Primes d'enrôlement",
        "link": "/superAdmin/AgentsFinance/Enrollement",
        "icon": "ri-user-add-line"
      },
      {
        "label": "Primes de mobilisation",
        "link": "/superAdmin/AgentsFinance/Mobilisation",
        "icon": "ri-bar-chart-line"
      },
      {
        "label": "Historique paiements",
        "link": "/superAdmin/AgentsFinance/Historique",
        "icon": "ri-history-line"
      },

      
     
    ]
  }] : [];
  
  // ============================================================
  // MENU POUR LES AGENTS DE MARCHÉ (Admin Marché, Superviseur, Agent)
  // ============================================================
  const marketAgentMenu = [
    // Tableau de bord Marché
    {
      "label": "Tableau de Bord",
      "link": "/supervisor/dashboard",
      "icon": "ri-store-3-line",
    },
    
    // Marchés - Sans sous-menu
    ...(canSeeMarches ? [{
      "label": "Marchés",
      "link": "/gestion/Marches",
      "icon": "ri-store-line"
    }] : []),

    // Collecte
    {
      "label": "Collecte",
      "icon": "ri-money-dollar-circle-line",
      "submenu": [
        {
          "label": "Historique des collectes",
          "link": "/contribuables/CollectesUsagers",
          "icon": "ri-history-line"
        },
        {
          "label": "Rapports de collecte",
          "link": "/contribuables/Rapport",
          "icon": "ri-file-chart-line"
        }
      ]
    },
    
    // Contribuables
    {
      "label": "Contribuables",
      "icon": "ri-user-line",
      "submenu": [
        {
          "label": "Rechercher contribuable",
          "link": "/agent/contribuables/search",
          "icon": "ri-search-line"
        },
        {
          "label": "Liste des contribuables",
          "link": "/agent/contribuables/liste",
          "icon": "ri-list-check"
        },
        {
          "label": "Avis de passages",
          "link": "/agent/contribuables/avis-passage",
          "icon": "ri-file-paper-2-line"
        },
        {
          "label": "Ajouter contribuable",
          "link": "/agent/contribuables/new",
          "icon": "ri-add-line"
        },
        {
          "label": "Cartographie",
          "link": "/agent/contribuables/cartographie",
          "icon": "ri-map-pin-user-line"
        }
      ]
    },
    
    // ✅ TAXES ou REDEVANCES
    {
      "label": useRedevances ? "Redevances" : "Taxes",
      "icon": "ri-list-check",
      "submenu": [
        {
          "label": useRedevances ? "Liste des redevances" : "Liste des taxes",
          "link": "/superAdmin/Taxes",
          "icon": "ri-list-check"
        },
        {
          "label": useRedevances ? "Catégories redevances" : "Catégories des taxes",
          "link": "/admin/CategoriesTaxes",
          "icon": "ri-list-check"
        }
      ]
    },
    
    // Types d'Activités
    {
      "label": "Types d'Activités",
      "icon": "ri-list-check",
      "submenu": [
        {
          "label": "Liste d'activités",
          "link": "/agent/contribuables/Activites",
          "icon": "ri-list-check"
        },
        {
          "label": "Ajout activité",
          "link": "/contribuables/activity/new",
          "icon": "ri-add-line"
        },
        {
          "label": "Catégories activités",
          "link": "/agent/contribuables/Categories",
          "icon": "ri-list-check"
        }
      ]
    },
    
    // 👈 NOUVEAU : Mes primes
    ...mesPrimesSection,
    
    // Objectifs - Caché pour les agents simples
    ...(canSeeObjectives ? [{
      "label": "Objectifs",
      "icon": "ri-flag-2-line",
      "link": "/supervisor/objectives",
    }] : []),
    
    // Rapports
 
    
    // Localités
    {
      "label": "Localités",
      "link": "/gestion/Localites",
      "icon": "ri-map-line"
    },
    
    // Agents - Caché pour les agents simples
    ...(canSeeAgents ? [
      {
      "label": "Agents",
      "icon": "ri-user-line",
      "submenu": [
        {
          "label": "Liste des agents",
          "link": "/superAdmin/Agents",
          "icon": "ri-list-check"
        },
        {
          "label": "Nouvel agent",
          "link": "/superAdmin/Agent/new",
          "icon": "ri-add-line"
        },
        {
          "label": "Primes d'enrôlement",
          "link": "/superAdmin/AgentsFinance/Enrollement",
          "icon": "ri-user-add-line",
          "roles": ['local', 'global']
        },
        {
          "label": "Primes de mobilisation",
          "link": "/superAdmin/AgentsFinance/Mobilisation",
          "icon": "ri-bar-chart-line",
          "roles": ['local', 'global']
        },
        {
          "label": "Historique paiements",
          "link": "/superAdmin/AgentsFinance/Historique",
          "icon": "ri-history-line",
          "roles": ['local', 'global']
        },
        {
          "label": "Performance des agents",
          "link": "/supervisor/agents-performance",
          "icon": "ri-bar-chart-2-line"
        }
      ]
    }] : []),
    
    // Rôles & permissions - Caché pour les agents simples
    ...(canSeeRoles ? [{
      "label": "Rôles & permissions",
      "link": "/superAdmin/DroitsPermissions",
      "icon": "ri-settings-3-line"
    }] : [])
  ];

  // ============================================================
  // MENU POUR LES ADMIN ENTITÉ (comme Super Admin mais avec marchés)
  // ============================================================
  const adminEntiteMenu = [
    // Tableau de bord simple
    {
      "label": "Tableau de Bord",
      "link": "/dashboard",
      "icon": "ri-dashboard-line"
    },
    
    // Tableau de bord consolidé
    {
      "label": "Tableau Bord Marchés",
      "link": "/consolidated/dashboard",
      "icon": "ri-global-line"
    },
    
    // Marchés
    {
      "label": "Marchés",
      "link": "/gestion/Marches",
      "icon": "ri-store-line"
    },

    // Collecte
    {
      "label": "Collecte",
      "icon": "ri-money-dollar-circle-line",
      "submenu": [
        {
          "label": "Historique des collectes",
          "link": "/contribuables/CollectesUsagers",
          "icon": "ri-history-line"
        },
        {
          "label": "Rapports de collecte",
          "link": "/contribuables/Rapport",
          "icon": "ri-file-chart-line"
        }
      ]
    },
    
    // Redevances marchés
    {
      "label": "Redevances",
      "icon": "ri-list-check",
      "submenu": [
        {
          "label": "Liste des redevances",
          "link": "/superAdmin/Taxes",
          "icon": "ri-list-check"
        },
        {
          "label": "Catégories redevances",
          "link": "/admin/CategoriesTaxes",
          "icon": "ri-list-check"
        }
      ]
    },
    
    // Types d'Activités
    {
      "label": "Types d'Activités",
      "icon": "ri-list-check",
      "submenu": [
        {
          "label": "Liste d'activités",
          "link": "/agent/contribuables/Activites",
          "icon": "ri-list-check"
        },
        {
          "label": "Ajout activité",
          "link": "/contribuables/activity/new",
          "icon": "ri-add-line"
        },
        {
          "label": "Catégories activités",
          "link": "/agent/contribuables/Categories",
          "icon": "ri-list-check"
        }
      ]
    },
    
    // Contribuables
    {
      "label": "Contribuables",
      "icon": "ri-user-line",
      "submenu": [
        {
          "label": "Rechercher contribuable",
          "link": "/agent/contribuables/search",
          "icon": "ri-search-line"
        },
        {
          "label": "Liste des contribuables",
          "link": "/agent/contribuables/liste",
          "icon": "ri-list-check"
        },
        {
          "label": "Avis de passages",
          "link": "/agent/contribuables/avis-passage",
          "icon": "ri-file-paper-2-line"
        },
        {
          "label": "Ajouter contribuable",
          "link": "/agent/contribuables/new",
          "icon": "ri-add-line"
        },
        {
          "label": "Cartographie",
          "link": "/agent/contribuables/cartographie",
          "icon": "ri-map-pin-user-line"
        }
      ]
    },
    
    // Agents
    {
      "label": "Agents",
      "icon": "ri-user-line",
      "submenu": [
        {
          "label": "Liste des agents",
          "link": "/superAdmin/Agents",
          "icon": "ri-list-check"
        },
        {
          "label": "Nouvel agent",
          "link": "/superAdmin/Agent/new",
          "icon": "ri-add-line"
        },
        {
          "label": "Primes d'enrôlement",
          "link": "/superAdmin/AgentsFinance/Enrollement",
          "icon": "ri-user-add-line",
          "roles": ['local', 'global']
        },
        {
          "label": "Primes de mobilisation",
          "link": "/superAdmin/AgentsFinance/Mobilisation",
          "icon": "ri-bar-chart-line",
          "roles": ['local', 'global']
        },
        {
          "label": "Historique paiements",
          "link": "/superAdmin/AgentsFinance/Historique",
          "icon": "ri-history-line",
          "roles": ['local', 'global']
        },
        {
          "label": "Performance des agents",
          "link": "/supervisor/agents-performance",
          "icon": "ri-bar-chart-2-line"
        }
      ]
    },
    
    // Localités
    {
      "label": "Localités",
      "link": "/gestion/Localites",
      "icon": "ri-map-line"
    },
    
    // Rôles & permissions
    {
      "label": "Rôles & permissions",
      "link": "/superAdmin/DroitsPermissions",
      "icon": "ri-settings-3-line"
    },
    
    // Analyse Salubrité
    {
      "label": "Analyse Salubrité",
      "link": "/consolidated/salubrite",
      "icon": "ri-leaf-line"
    },
    {
  "label": "Analyse Loyers",
  "link": "/consolidated/loyers",
  "icon": "ri-home-4-line"
}
  ];

  // ============================================================
  // MENU POUR LES SUPER ADMIN
  // ============================================================
  const superAdminMenu = [
    // Tableau de bord simple
    {
      "label": "Tableau de Bord",
      "link": "/dashboard",
      "icon": "ri-dashboard-line"
    },
    
    // Tableau de bord consolidé
    {
      "label": "Tableau Bord Marchés",
      "link": "/consolidated/dashboard",
      "icon": "ri-global-line"
    },
    
    // Entités
    {
      "label": "Entités",
      "icon": "ri-user-line",
      "submenu": [
        {
          "label": "Liste des entités",
          "link": "/superAdmin/Entites",
          "icon": "ri-list-check"
        },
        {
          "label": "Nouvelle entité",
          "link": "/superAdmin/nouvelEntite",
          "icon": "ri-add-line"
        }
      ]
    },
    
    // Marchés
    {
      "label": "Marchés",
      "link": "/gestion/Marches",
      "icon": "ri-store-line"
    },

    // Collecte
    {
      "label": "Collecte",
      "icon": "ri-money-dollar-circle-line",
      "submenu": [
        {
          "label": "Historique des collectes",
          "link": "/contribuables/CollectesUsagers",
          "icon": "ri-history-line"
        },
        {
          "label": "Rapports de collecte",
          "link": "/contribuables/Rapport",
          "icon": "ri-file-chart-line"
        }
      ]
    },
    
    // Taxes
    {
      "label": "Taxes",
      "icon": "ri-list-check",
      "submenu": [
        {
          "label": "Liste des taxes",
          "link": "/superAdmin/Taxes",
          "icon": "ri-list-check"
        },
        {
          "label": "Catégories des taxes",
          "link": "/admin/CategoriesTaxes",
          "icon": "ri-list-check"
        }
      ]
    },
    
    // Types d'Activités
    {
      "label": "Types d'Activités",
      "icon": "ri-list-check",
      "submenu": [
        {
          "label": "Liste d'activités",
          "link": "/agent/contribuables/Activites",
          "icon": "ri-list-check"
        },
        {
          "label": "Ajout activité",
          "link": "/contribuables/activity/new",
          "icon": "ri-add-line"
        },
        {
          "label": "Catégories activités",
          "link": "/agent/contribuables/Categories",
          "icon": "ri-list-check"
        }
      ]
    },
    
    // Contribuables
    {
      "label": "Contribuables",
      "icon": "ri-user-line",
      "submenu": [
        {
          "label": "Rechercher contribuable",
          "link": "/agent/contribuables/search",
          "icon": "ri-search-line"
        },
        {
          "label": "Liste des contribuables",
          "link": "/agent/contribuables/liste",
          "icon": "ri-list-check"
        },
        {
          "label": "Avis de passages",
          "link": "/agent/contribuables/avis-passage",
          "icon": "ri-file-paper-2-line"
        },
        {
          "label": "Ajouter contribuable",
          "link": "/agent/contribuables/new",
          "icon": "ri-add-line"
        },
        {
          "label": "Cartographie",
          "link": "/agent/contribuables/cartographie",
          "icon": "ri-map-pin-user-line"
        }
      ]
    },
    
    // Formes juridiques
    {
      "label": "Formes juridiques",
      "link": "/superAdmin/Formes",
      "icon": "ri-list-check"
    },
    
    // Agents
    {
      "label": "Agents",
      "icon": "ri-user-line",
      "submenu": [
        {
          "label": "Liste des agents",
          "link": "/superAdmin/Agents",
          "icon": "ri-list-check"
        },
        {
          "label": "Nouvel agent",
          "link": "/superAdmin/Agent/new",
          "icon": "ri-add-line"
        },
        {
          "label": "Primes d'enrôlement",
          "link": "/superAdmin/AgentsFinance/Enrollement",
          "icon": "ri-user-add-line",
          "roles": ['local', 'global']
        },
        {
          "label": "Primes de mobilisation",
          "link": "/superAdmin/AgentsFinance/Mobilisation",
          "icon": "ri-bar-chart-line",
          "roles": ['local', 'global']
        },
        {
          "label": "Historique paiements",
          "link": "/superAdmin/AgentsFinance/Historique",
          "icon": "ri-history-line",
          "roles": ['local', 'global']
        },
        {
          "label": "Performance des agents",
          "link": "/supervisor/agents-performance",
          "icon": "ri-bar-chart-2-line"
        }
      ]
    },
    
    // Localités
    {
      "label": "Localités",
      "link": "/gestion/Localites",
      "icon": "ri-map-line"
    },
    
    // Rôles & permissions
    {
      "label": "Rôles & permissions",
      "link": "/superAdmin/DroitsPermissions",
      "icon": "ri-settings-3-line"
    },
    
    // Moyens de paiement
    {
      "label": "Moyens de paiement",
      "link": "/superAdmin/MoyensPaiement",
      "icon": "ri-currency-line"
    },
    
    // Notifications
    {
      "label": "Notifications",
      "link": "/superAdmin/Notifications",
      "icon": "ri-notification-line"
    },
    
    // Logs
    {
      "label": "Logs",
      "link": "/superAdmin/Logs",
      "icon": "ri-tools-line"
    },
    
    // Versions APK
    {
      "label": "Versions APK",
      "link": "/superAdmin/app-versions",
      "icon": "ri-android-line"
    }
  ];

  // ============================================================
  // MENU POUR LES UTILISATEURS SANS MARCHÉ (Admin Principal, Agents sans marché, etc.)
  // ============================================================
  const nonMarketUserMenu = [
    // Tableau de bord simple - PAS pour Admin Principal
    ...(canSeeSimpleDashboard ? [{
      "label": "Tableau de Bord",
      "link": "/dashboard",
      "icon": "ri-dashboard-line"
    }] : []),
    
    // Tableau de bord consolidé (Admin Principal)
    ...(isAdminPrincipal ? [{
      "label": "Tableau Bord Marchés",
      "link": "/consolidated/dashboard",
      "icon": "ri-global-line"
    }] : []),
    
    // Marchés - Sans sous-menu
    ...(canSeeMarches ? [{
      "label": "Marchés",
      "link": "/gestion/Marches",
      "icon": "ri-store-line"
    }] : []),

    // Collecte
    {
      "label": "Collecte",
      "icon": "ri-money-dollar-circle-line",
      "submenu": [
        {
          "label": "Historique des collectes",
          "link": "/contribuables/CollectesUsagers",
          "icon": "ri-history-line"
        },
        {
          "label": "Rapports de collecte",
          "link": "/contribuables/Rapport",
          "icon": "ri-file-chart-line"
        }
      ]
    },
    
    // Taxes
    {
      "label": "Taxes",
      "icon": "ri-list-check",
      "submenu": [
        {
          "label": "Liste des taxes",
          "link": "/superAdmin/Taxes",
          "icon": "ri-list-check"
        },
        {
          "label": "Catégories des taxes",
          "link": "/admin/CategoriesTaxes",
          "icon": "ri-list-check"
        }
      ]
    },
    
    // Types d'Activités
    {
      "label": "Types d'Activités",
      "icon": "ri-list-check",
      "submenu": [
        {
          "label": "Liste d'activités",
          "link": "/agent/contribuables/Activites",
          "icon": "ri-list-check"
        },
        {
          "label": "Ajout activité",
          "link": "/contribuables/activity/new",
          "icon": "ri-add-line"
        },
        {
          "label": "Catégories activités",
          "link": "/agent/contribuables/Categories",
          "icon": "ri-list-check"
        }
      ]
    },
    
    // Contribuables
    {
      "label": "Contribuables",
      "icon": "ri-user-line",
      "submenu": [
        {
          "label": "Rechercher contribuable",
          "link": "/agent/contribuables/search",
          "icon": "ri-search-line"
        },
        {
          "label": "Liste des contribuables",
          "link": "/agent/contribuables/liste",
          "icon": "ri-list-check"
        },
        {
          "label": "Avis de passages",
          "link": "/agent/contribuables/avis-passage",
          "icon": "ri-file-paper-2-line"
        },
        {
          "label": "Ajouter contribuable",
          "link": "/agent/contribuables/new",
          "icon": "ri-add-line"
        },
        {
          "label": "Cartographie",
          "link": "/agent/contribuables/cartographie",
          "icon": "ri-map-pin-user-line"
        }
      ]
    },
    
    // 👈 NOUVEAU : Mes primes (pour les agents SANS marché)
    ...mesPrimesSection,
    
    // Agents - Caché pour les agents simples
    ...(canSeeAgents ? [
      {
      "label": "Agents",
      "icon": "ri-user-line",
      "submenu": [
        {
          "label": "Liste des agents",
          "link": "/superAdmin/Agents",
          "icon": "ri-list-check"
        },
        {
          "label": "Nouvel agent",
          "link": "/superAdmin/Agent/new",
          "icon": "ri-add-line"
        },
        {
          "label": "Primes d'enrôlement",
          "link": "/superAdmin/AgentsFinance/Enrollement",
          "icon": "ri-user-add-line",
          "roles": ['local', 'global']
        },
        {
          "label": "Primes de mobilisation",
          "link": "/superAdmin/AgentsFinance/Mobilisation",
          "icon": "ri-bar-chart-line",
          "roles": ['local', 'global']
        },
        {
          "label": "Historique paiements",
          "link": "/superAdmin/AgentsFinance/Historique",
          "icon": "ri-history-line",
          "roles": ['local', 'global']
        },
        {
          "label": "Performance des agents",
          "link": "/supervisor/agents-performance",
          "icon": "ri-bar-chart-2-line"
        }
      ]
    }] : []),
    
    // Localités
    {
      "label": "Localités",
      "link": "/gestion/Localites",
      "icon": "ri-map-line"
    },
    
    // Rôles & permissions - Caché pour les agents simples
    ...(canSeeRoles ? [{
      "label": "Rôles & permissions",
      "link": "/superAdmin/DroitsPermissions",
      "icon": "ri-settings-3-line"
    }] : []),
    
    // Analyse Salubrité (Admin Principal uniquement)
    ...(isAdminPrincipal ? [{
      "label": "Analyse Salubrité",
      "link": "/consolidated/salubrite",
      "icon": "ri-leaf-line"
    },{
  "label": "Analyse Loyers",
  "link": "/consolidated/loyers",
  "icon": "ri-home-4-line"
}] : [])
  ];

  // ============================================================
  // SÉLECTION DU MENU APPROPRIÉ
  // ============================================================
  
  // ✅ Super Admin
  if (isSuperAdmin) {
    return superAdminMenu;
  }
  
  // ✅ Admin Entité (1002) - menu hybride
  if (isAdminEntite) {
    return adminEntiteMenu;
  }
  
  // ✅ Si l'utilisateur est un agent de marché (a un marché)
  if (isAgent) {
    return marketAgentMenu;
  }
  
  // ✅ Sinon (utilisateur sans marché ou Admin Principal ou Agent sans marché)
  return nonMarketUserMenu;
};

export { getDashboardMenu };